import React from "react"
import { Link } from "react-router-dom"

import SEO from "../components/common/SEO"

export default function NotFound() {
  return (
    <>
      {/* SEO */}
      <SEO
        title="Page Not Found | Spa Center"
        description="The page you are looking for does not exist."
        url="https://www.yourdomain.com/404"
      />

      <main className="min-h-screen flex items-center justify-center bg-[#f9f6f1] px-4">
        <div className="text-center max-w-md">
          <h1 className="text-6xl font-bold text-[#b8955d]">404</h1>

          <h2 className="text-2xl md:text-3xl font-semibold text-[#111111] mt-4">
            Page Not Found
          </h2>

          <p className="text-gray-600 mt-4 leading-relaxed">
            The page you are looking for doesn’t exist or has been moved.
          </p>

          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center justify-center bg-[#b8955d] text-white px-6 py-3 rounded-full font-medium hover:bg-[#9f7d48] transition"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </main>
    </>
  )
}